import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import baseuri from '../../baseuri';

interface WithdrawalItem {
	investmentId: any;
	withdrawalStatus: string;
	status: string;
}

export const registerInvestment = createAsyncThunk(
	'investment/registerInvestment',
	async (data: any) => {
		try {
			const res = await baseuri.post('/admin/investments/register', data);
			message.success('Investment started successfully');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			throw new Error(e);
		}
	}
);
export const startProxyInvestment = createAsyncThunk(
	'investment/startProxyInvestment',
	async (data: any) => {
		try {
			const res = await baseuri.post('/admin/proxy-investments/start', data);
			message.success(res.data.message);
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const createProxyInvestment = createAsyncThunk(
	'investment/createProxyInvestment',
	async (data: any) => {
		try {
			const res = await baseuri.post('/admin/proxy-investments', data);
			message.success('Investment created successfully');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const retrieveInvestmentItems = createAsyncThunk(
	'investment/retrieveInvestmentItems',
	async (params: any) => {
		const res = await baseuri.get('/admin/proxy-investments', {
			params,
		});
		return res.data.data;
	}
);

export const retrieveAdminInvestmentItems = createAsyncThunk(
	'investment/retrieveAdminInvestmentItems',
	async (params: any) => {
		const res = await baseuri.get('/admin/investments', {
			params,
		});

		return res.data.data;
	}
);

export const unregisteredInvestmentItems = createAsyncThunk(
	'investment/unregisteredInvestmentItems',
	async (params: any) => {
		const res = await baseuri.get(
			'/admin/users/investment-users-unregistered',
			{
				params,
			}
		);

		return res.data.data;
	}
);

export const investmentStatusCount = createAsyncThunk(
	'investment/investmentStatusCount',
	async (params: any) => {
		const res = await baseuri.get('/admin/investments/status/counts', {
			params,
		});
		return res.data.data;
	}
);
export const investmentTransactionStatements = createAsyncThunk(
	'investment/investmentTransactionStatements',
	async (params: any) => {
		const res = await baseuri.get('/admin/statements/transactions', {
			params,
		});
		return res.data.data;
	}
);

export const investmentTopUpList = createAsyncThunk(
	'investment/investmentTopUpList',
	async (params: any) => {
		const res = await baseuri.get('/admin/investments/top-ups', {
			params,
		});
		return res.data.data;
	}
);

export const investmentTopUpStatusCount = createAsyncThunk(
	'investment/investmentTopUpStatusCount',
	async (params: any) => {
		const res = await baseuri.get('/admin/investments/top-ups/counts', {
			params,
		});
		return res.data.data;
	}
);

export const investmentWalletBalance = createAsyncThunk(
	'investment/investmentWalletBalance',
	async (params: any) => {
		const res = await baseuri.get('/admin/investments/wallet/BALANCE', {
			params,
		});
		return res.data.data;
	}
);

export const migrateInvestmentTopUp = createAsyncThunk(
	'investment/migrateInvestmentTopUp',
	async (data: any) => {
		try {
			const res = await baseuri.post('/admin/investments/fund', data);
			message.success('Investment migration was successful');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const topUpInvestment = createAsyncThunk(
	'investment/topUpInvestment',
	async (data: any) => {
		try {
			const res = await baseuri.post('/admin/proxy-investments/top-up', data);
			message.success('Investment topUp created successfully');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const startWithdrawal = createAsyncThunk(
	'investment/startWithdrawal',
	async (data: any) => {
		try {
			const res = await baseuri.post('/admin/investments/withdraw', data);
			message.success('Investment withdrawal initiated successfully');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const investmentWithdrawals = createAsyncThunk(
	'investment/investmentWithdrawals',
	async (params: any) => {
		const res = await baseuri.get('/admin/investments/withdrawals', {
			params,
		});
		return res.data.data;
	}
);

export const investmentWithdrawalStatusCount = createAsyncThunk(
	'investment/investmentWithdrawalStatusCount',
	async (params: any) => {
		const res = await baseuri.get('/admin/investments/withdrawal/counts', {
			params,
		});
		return res.data.data;
	}
);
export const validateProxyWithdrawal = createAsyncThunk(
	'investment/validateProxyWithdrawal',
	async (params: any) => {
		try {
			const res = await baseuri.get(
				'/admin/proxy-investments/withdrawals/validate',
				{
					params,
				}
			);
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const startProxyWithdrawal = createAsyncThunk(
	'investment/startProxyWithdrawal',
	async (data: any) => {
		try {
			const res = await baseuri.post('/admin/proxy-investments/withdraw', data);
			message.success(res.data.message);
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const resetProxyWithdrawal = createAsyncThunk(
	'investment/resetProxyWithdrawal',
	() => ({
		allowedWithdrawal: false,
		amount: 0,
		creditAmount: 0,
		investmentStatus: '',
		maxWithdrawableAmount: 0,
		transactionFee: 0,
		validationCode: '',
	})
);

export const banUserInvestment = createAsyncThunk(
	'investment/banUserInvestment',
	async (data: any) => {
		try {
			const res = await baseuri.post('/admin/proxy-investments/ban', data);
			message.success('Investment withdrawal initiated successfully');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const approveWithdrawal = createAsyncThunk(
	'investment/approveWithdrawal',
	async (data: any) => {
		try {
			const res = await baseuri.post(
				'/admin/investments/withdrawals/approve',
				data
			);
			message.success(res?.data?.message);
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const processWithdrawal = createAsyncThunk(
	'investment/processWithdrawal',
	async (data: any) => {
		try {
			const res = await baseuri.post(
				'/admin/investments/withdrawals/process',
				data
			);
			message.success(res?.data?.message);
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const rejectWithdrawal = createAsyncThunk(
	'investment/rejectWithdrawal',
	async (data: any) => {
		try {
			const res = await baseuri.post(
				'/admin/investments/withdrawals/reject',
				data
			);

			message.success(res?.data?.message);
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);
const investmentRx = createSlice({
	name: 'investment',
	initialState: {
		investmentItems: {
			itemsList: [
				{
					currencyId: {
						symbol: '',
					},
				},
			],
			paginator: {
				perPage: 20,
				itemCount: 0,
				currentPage: 1,
			},
			investment: {},
			topUps: [],
			withdrawals: [],
		},
		adminInvestmentItems: {
			itemsList: [],
			paginator: {
				perPage: 20,
				itemCount: 0,
				currentPage: 1,
			},
			investment: {},
			investmentProfile: {
				active: false,
				assetType: '',
				category: '',
				currentBalance: 0,
				customer: '',
				duration: 0,
				frequency: '',
				goalTimeline: 0,
				investmentId: '',
				isArchived: false,
				isClosed: false,
				isRecurring: false,
				maturityDate: null,
				tag: '',
				totalDeposited: 0,
				totalFunded: 0,
				totalReturns: 0,
				totalWithdrawn: 0,
				type: '',
				createdAt: '',
				updatedAt: '',
			},
			investmentReturns: {
				customer: '',
				investmentId: '',
				returns: [],
				returnPercent: 0,
				totalDeposited: 0,
				totalReturns: 0,
				totalWithdrawn: 0,
			},
			topUps: [],
			withdrawals: [],
		},
		unregisteredInvestments: {
			itemsList: [],
			paginator: {
				perPage: 20,
				itemCount: 0,
				currentPage: 1,
			},
		},
		investmentStatus: {
			running: 0,
			completed: 0,
			terminated: 0,
		},
		investmentStatements: {
			itemsList: [],
			paginator: {
				perPage: 20,
				itemCount: 0,
				currentPage: 1,
			},
		},
		investmentTopUps: {
			topUps: {
				itemsList: [],
				paginator: {
					perPage: 20,
					itemCount: 0,
					currentPage: 1,
				},
			},
			totalAmount: 0,
		},
		investmentTopUpStatus: {
			migrated: 0,
			pendingMigrate: 0,
			all: 0,
		},
		investmentBal: {
			balance: 0,
			currency: 0,
		},
		withdrawalList: {
			itemsList: [] as WithdrawalItem[] | WithdrawalItem,
			paginator: {
				perPage: 20,
				itemCount: 0,
				currentPage: 1,
			},
		},
		investmentWithdrawalStatus: {
			review: 0,
			completed: 0,
			pending: 0,
			processing: 0,
			cancelled: 0,
		},
		withdrawalValidate: {
			allowedWithdrawal: false,
			amount: 0,
			creditAmount: 0,
			investmentStatus: '',
			maxWithdrawableAmount: 0,
			transactionFee: 0,
			validationCode: '',
		},
	},
	reducers: {},
	extraReducers: (builder) =>
		builder
			.addCase(retrieveInvestmentItems.fulfilled, (store, action) => {
				const state = store;
				state.investmentItems = action.payload;
			})
			.addCase(retrieveAdminInvestmentItems.fulfilled, (store, action) => {
				const state = store;
				state.adminInvestmentItems = action.payload;
			})
			.addCase(unregisteredInvestmentItems.fulfilled, (store, action) => {
				const state = store;
				state.unregisteredInvestments = action.payload;
			})
			.addCase(investmentStatusCount.fulfilled, (store, action) => {
				const state = store;
				state.investmentStatus = action.payload;
			})
			.addCase(investmentTransactionStatements.fulfilled, (store, action) => {
				const state = store;
				state.investmentStatements = action.payload;
			})
			.addCase(investmentTopUpList.fulfilled, (store, action) => {
				const state = store;
				state.investmentTopUps = action.payload;
			})
			.addCase(investmentTopUpStatusCount.fulfilled, (store, action) => {
				const state = store;
				state.investmentTopUpStatus = action.payload;
			})
			.addCase(investmentWalletBalance.fulfilled, (store, action) => {
				const state = store;
				state.investmentBal = action.payload;
			})
			.addCase(investmentWithdrawals.fulfilled, (store, action) => {
				const state = store;
				state.withdrawalList = action.payload;
			})
			.addCase(investmentWithdrawalStatusCount.fulfilled, (store, action) => {
				const state = store;
				state.investmentWithdrawalStatus = action.payload;
			})
			.addCase(validateProxyWithdrawal.fulfilled, (store, action) => {
				const state = store;
				state.withdrawalValidate = action.payload;
			})
			.addCase(resetProxyWithdrawal.fulfilled, (store, action) => {
				const state = store;
				state.withdrawalValidate = action.payload;
			}),
});

export default investmentRx.reducer;
